// extracted by mini-css-extract-plugin
module.exports = {"modal":"_3KQZmv5k33VY1PPFMZtdAc backgroundColor textColor","container":"_22VHPJOmYuUJ2vgEgr1peC","height":"_19d2jBbLPz4nqvxkWiMcnC"};